export enum CampaignType {
  Registered,
  Enrollment,
  NotRegistered,
  Adviced,
  AddToBasket,
  SendComment,
}
